import { DOM, breakpoints, classes, matchMedia, matchMediaMax } from '../const';

const { isActive } = classes;

const { $window, $hbody } = DOM;

const checkPositions = $$elems => {
  $$elems.each((i, el) => {
    let left = '0';
    let bottom = '0';

    if (matchMediaMax(breakpoints.xs - 1)) {
      left = String($(el).data(`xs-l`));
      bottom = String($(el).data(`xs-b`));
    } else {
      Object.keys(breakpoints).forEach(b => {
        const elLeft = $(el).data(`${b}-l`);
        const elBottom = $(el).data(`${b}-b`);
        const mediaMatches = matchMedia(breakpoints[b]);
        const mediaExists = elLeft !== undefined || elBottom !== undefined;

        if (mediaMatches && mediaExists) {
          left = String(elLeft);
          bottom = String(elBottom);
        }
      });
    }

    $(el).css({
      left: `${left}%`,
      bottom: `${bottom}%`
    });

  });
};

const initHotspot = $el => {
  const $$tabLinks = $el.find('.js-hotspot-btn');
  const $$tabs = $el.find('.js-hotspot-tab');

  checkPositions($$tabLinks);
  checkPositions($$tabs);

  $$tabLinks.each((i, el) => {
    const tabId = $(el).data('tab');
    $(el).click(event => {
      event.preventDefault();

      $(el).addClass(isActive);
      $$tabLinks.each((j, tablink) => {
        if (tablink !== el) {
          $(tablink).removeClass(isActive);
        }
      });

      $$tabs.each((j, tab) => {
        const $parent = $(tab).parent();
        if ($parent.data('tab') === tabId) {
          $parent.addClass(isActive);

          const tabTop =  $(tab).offset().top - 20;
          const textIsInvisible = tabTop < $window.scrollTop();

          if (textIsInvisible) {
            $hbody.animate({
              scrollTop: $(tab).offset().top - 40
            }, 400);
          }
        } else {
          $parent.removeClass(isActive);
        }
      });

    });
  });

  $(window).resize(() => {
    checkPositions($$tabLinks);
    checkPositions($$tabs);
  });
};

const hotspots = () => {
  const $$hotspots = $('.js-hotspot');

  $$hotspots.each((i, el) => {
    initHotspot($(el));
  });
};

export default hotspots;
